import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { getIssueById, addIssue, updIssue, addIssueByCommunity } from '../../actions/issueAction';
import { getAllItems, getItemsByCommunity } from '../../actions/itemAction';

import { renderTextField, renderSwitchWithLabel } from '../../utils/engageComponents'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import PropTypes from 'prop-types';
import { Tab, Tabs } from '@material-ui/core';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';

import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { renderImage } from '../../utils/engageComponents'
import { sweetAlert } from "../../components/Alert/sweetAlert";

import {
    ADD_ISSUE_SUCCESS,
    UPDATE_ISSUE_SUCCESS
} from "../../constants/issueConstant";

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The issue must have less than ${props.characterLimit} characters`
    }

    return errors;
};

  const  TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={1}>
            <Grid>{children}</Grid>
          </Box>
        )}
      </div>
    );
  };

  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };


class AddEditIssue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props.data._id,
            items : props.items,
            itemsByIssue: this.props.data.items ? [...this.props.data.items]: [],
            tab:0,
            openModal:false,
            nameEs:'',
            nameFr:'', 
            waterDamage:false,
            residentDiscomfort:false
        };

        if (props.data) {
            this.props.dispatch(change('IssueForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('IssueForm', 'name', props.data && props.data.name));
        } else {
            this.props.dispatch(change('IssueForm', '_id', ''));
            this.props.dispatch(change('IssueForm', 'name', ''));
        }
    }


    //This method will run once the componnet is deploy to the browser
    componentDidMount(){
        if(this.props.data !== '') 
            this.props.getIssueById(this.props.data._id)


        if(this.props.data){
            this.setState({
                waterDamage:this.props.data.waterDamage,
                residentDiscomfort:this.props.data.residentDiscomfort
            })
        }

        if(this.props.data?.translations && this.props.data.translations.length>0){

            const spanishObj = this.props.data.translations.find(x=>x.languageCode==='es');
    
            const frenchObj = this.props.data.translations.find(x=>x.languageCode==='fr');

            if(spanishObj){
                this.setState({nameEs:spanishObj.name});
    
                this.props.dispatch(change('IssueForm','nameEs', spanishObj.name)) ;

            }
    
            if(frenchObj){
                this.setState({nameFr:frenchObj.name});
                this.props.dispatch(change('IssueForm','nameFr', frenchObj.name)) ;
    
            }
    
        }

        this.props.getItemsByCommunity(localStorage.getItem('communityId'));

    }



    //This methos is responsable to handle the click in cancel button 
    //it does set state prop OPEN to false so in a rerender this component will not be render (it render the list of issues)
    //set the prop itemsByissue to []
    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.setState({ itemsByIssue: [] })
            this.props.closeDialog();
        }
    };

    //This method handle the click in save button and depending on if state._id is defined it call method update else it call add method
    //and call closeDialog send as a property by Issue.jsx
    onSubmitHandler = (formData) => {

        formData.items = this.state.itemsByIssue

        if (formData.name.length > this.props.characterLimit) {
            const message = `The issue must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditIssue_MaxCharacters_Error');
            return;
        }

        formData.translations=[];

        if(this.state.nameEs!==''){
            const spanishObj={
                languageCode:'es',
                name:this.state.nameEs,
            }

            formData.translations.push(spanishObj);
        }

        if(this.state.nameFr!==''){
            const frenchObj={
                languageCode:'fr',
                name:this.state.nameFr,
            }

            formData.translations.push(frenchObj);
        }

        //Indicators info
        formData.waterDamage = this.state.waterDamage;
        formData.residentDiscomfort = this.state.residentDiscomfort;

        if(!this.state._id){
            this.props.addIssueByCommunity(formData, localStorage.getItem('communityId')); //this.state._id);
        }
        else {
            this.props.updIssue(this.state._id, formData); //this.state._id);
        }

        this.setState({ itemsByIssue: [] });
    };


    //this method handle the chek of the checkboxes in the list of issues
    handleToggle = (value) => {
        if (!this.state.itemsByIssue) {
            const newChecked = [];
            newChecked.push(value);

            this.setState({ itemsByIssue: newChecked })
        } else {
            const currentIndex = this.state.itemsByIssue.indexOf(value);
            const newChecked = this.state.itemsByIssue;

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }

            this.setState({ itemsByIssue: newChecked })
        }

        this.isSwitchChecked();
    };


    //This methos select every element in the list and put them in the itemsByIssue array 
    handleChange = (event) => {
        //setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked)
            this.setState({ itemsByIssue: (this.props && this.props.items && this.props.items.length > 0) ? this.props.items.map(item => item._id) : [] })
        else
            this.setState({ itemsByIssue: [] })
    };

    //handle the state of the switch
    isSwitchChecked = () => {
        let isChecked = false;

        if (this.props.items && this.state.itemsByIssue) {
            isChecked = !this.props.items.some((i) => this.state.itemsByIssue.indexOf(i._id) === -1);
        }


        return isChecked;
    }
    handleChangeTab = (event, newValue) => {
        this.setState({tab:newValue});
    };

    a11yProps(lng) {
        return {
          id: `vertical-translation-tab-${lng}`,
          'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex =(index)=>{
        this.setState({tab:index})
    }


    render() {
        const { handleSubmit } = this.props;

        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isIssueSuccess.success && (this.props.isIssueSuccess.type === ADD_ISSUE_SUCCESS || this.props.isIssueSuccess.type === UPDATE_ISSUE_SUCCESS)) {
            this.props.closeDialog(1);
        }

        return (
            <div className="FormDetailSubTitle-engage" style={{ width: '100%' }}>
                <form>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn_issues" className="appbtn-engage skybluebtn-engage" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id="cancel_btn_issues" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container className='formSection'>
                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                id='issues_add_issue_name'
                                name="name"
                                label="Name"
                                maxLength={20}
                                component={renderTextField}
                                inputClass='defaultTextStyles'
                                inputLabelClass='defaultTextStyles' />
                        </Grid>

                        <Grid item xs={12} sm={12}  md={6}></Grid>

                        <Grid item xs={12} sm={12} md={6} style={{marginTop:'1rem'}}>
                            <Field
                                labelInLeft={true}
                                name="waterDamage"
                                label="Water damage risk"
                                checked={this.state.waterDamage}
                                onClick={ () => {
                                    
                                    if(this.state.residentDiscomfort){
                                        sweetAlert('error','You can add just one indicator per issue')
                                    }else{
                                        this.setState((prevState) => ({waterDamage: !prevState.waterDamage   }))
                                    }                            
                                }}
                                component={renderSwitchWithLabel}
                                idToSet='water_damage_switch'
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={{marginTop:'1rem'}}>
                            <Field
                                labelInLeft={true}
                                name="residentDiscomfort"
                                label="Resident discomfort risk"
                                checked={this.state.residentDiscomfort}
                                onClick={ () =>{ 
                                    if(this.state.waterDamage){
                                        sweetAlert('error','You can add just one indicator per issue')
                                    }else{
                                        this.setState((prevState) => ({residentDiscomfort: !prevState.residentDiscomfort   }))
                                    }
                                }}
                                component={renderSwitchWithLabel}
                                idToSet='resident_discomfort_switch'
                            />
                        </Grid>
                    </Grid>

                    <Grid item container className='formSection' style={{ marginTop: '30px' }}>
                        <Grid item container>
                            <Grid item xs={12}>
                                <p className="category defaultTextStyles" >Items list</p>
                                <div style={{ textAlign: 'left' }} >
                                    <Grid item xs={6} md={4} lg={2} style={{ padding: '10px', paddingTop: '40px' }}>
                                        <Field
                                            name="selectAll"
                                            label="Select All"
                                            checked={this.isSwitchChecked()}
                                            onClick={this.handleChange}
                                            component={renderSwitchWithLabel}
                                            idToSet='selectAlltoogle'
                                            id='selectAlltoogle'

                                        />
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {
                                this.props.items && this.props.items.map((itemRoom, index) => {
                                    return (
                                        <Grid xs={12} sm={6} md={3} style={{ padding: '4px' }} key={'GridIssue' + index} >
                                            <Card key={index} className=" cardElement" id={`issues_items_card_${itemRoom._id}`}>
                                                <CardContent className="card-center-container medium" style={{ height: '100px' }}>
                                                    {
                                                        renderImage(itemRoom)
                                                    }
                                                </CardContent>
                                                <CardActions className="card-center-container CardActions">
                                                    <Grid item container xs={12} alignContent='center' style={{ height: '100%', overflow: 'hidden' }}>
                                                        <Grid item container xs={4}>
                                                            <Grid item container className='CheckboxBlue RepairsCell' justify='center' alignContent='center'>
                                                                <Checkbox
                                                                    id={`checkbox_${itemRoom._id}`}
                                                                    checked={this.state.itemsByIssue ? this.state.itemsByIssue.indexOf(itemRoom._id) !== -1 : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.handleToggle(itemRoom._id)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={8} alignContent='center' justify='center' style={{ overflow: 'hidden' }}>
                                                            <Grid item className='WrapText  engage_Title'>
                                                                {
                                                                    itemRoom.name
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </Grid>
                 
                    <Modal
                        open={this.props.openTranslation}
                        onClose={this.props.closeTranslations}
                    >
                        <Paper elevation={3}>
                            <Grid className='translationsModal'>
                                <Grid className="ModalTitle">Add translations</Grid>
                                <Grid item container xs={12} style={{marginTop:'1rem', marginBotton:'1rem'}}>
                                    <Tabs
                                        value={this.state.tab}
                                        onChange={this.handleChangeTab}
                                        aria-label="Translations tab"
                                        className='translationTabs'
                                        TabIndicatorProps={{style:{backgroundColor:'#009edd'}}}

                                    >
                                        <Tab label="ES" className={(this.state.tab === 0)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(0)} />
                                        <Tab label="FR" className={(this.state.tab === 1)?   "SelectedTranslationTabs": "translationTab"} {...this.a11yProps(1)} />

                                    </Tabs>

                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.tab}
                                        onChangeIndex={this.handleChangeTranslationIndex}
                                    >

                                        <TabPanel value={0} index={0} className='translationTabContent'>
                                            <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="nameEs"
                                                        label="Nombre"
                                                        maxLength={20}
                                                        onChange={(e, newItem ) => this.setState({nameEs: newItem})}
                                                        component={renderTextField}
                                                        id='nameEs'
                                                    />  
                                                </Grid>
                                            </Grid>
                                        </TabPanel>
                                                                
                                        <TabPanel value={1} index={1} className='translationTabContent'>
                                            <Grid item container xs={12} style={{marginTop:'1rem'}}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="nameFr"
                                                        label="nom"
                                                        maxLength={20}
                                                        onChange={(e, newItem ) => this.setState({nameFr: newItem})}
                                                        component={renderTextField}
                                                        id='nameFr'
                                                    />  
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                    </SwipeableViews>

                                    <Grid item container xs={12} alignItems='center' justify='center' style={{marginTop:'1rem'}}>
                                        <Grid 
                                            item container justify='center' alignItems='center'
                                            onClick={this.props.closeTranslations} 
                                            className='RepairsModalButtonCancel alingCenter'
                                        >
                                            Cancel
                                        </Grid>
                                        <Grid 
                                            item container justify='center' alignItems='center'
                                            onClick={this.props.closeTranslations} 
                                            className='RepairsModalButtonSchedule alingCenter'
                                        >
                                            Ok
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </Paper>
                    
                    </Modal>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {

    let initialValuesData = {};
    if (state.issueReducer && state.issueReducer.issueData && state.issueReducer.issueData.data) {
        initialValuesData._id = state.issueReducer.issueData.data._id
        initialValuesData.name = state.issueReducer.issueData.data.name
    }

    const items = (state && state.itemReducer && state.itemReducer.itemData) ? state.itemReducer.itemData : []
    const issueSuccess = state.issueReducer;


    return {
        issueData: state.issueReducer && state.issueReducer.issueData,
        initialValues: initialValuesData,
        items: items,
        itemsByIssue: [],
        isIssueSuccess: issueSuccess
    };
}

export default connect(mapStateToProps, { getIssueById, addIssue, updIssue, getAllItems, getItemsByCommunity, addIssueByCommunity })(reduxForm({
    form: 'IssueForm',
    validate,
    enableReinitialize: true,
})(AddEditIssue));

